import React from 'react'
import styles from '../../CustomTable/components/MoreOptions/MoreOptions.module.css'

const Item = ({ icon, alt, label, onClick, hidden }) => {
  if (hidden) return null

  return (
    <div className={styles.contentBox} onClick={onClick}>
      <img src={`/assets/icons/${icon}`} alt={alt} className={styles.img} />
      <span className={styles.contentText}>{label}</span>
    </div>
  )
}

const DomainMoreOptions = ({ onAction, label, icon, items }) => {
  const menuItems = items || [{ icon: icon || 'trash.svg', label, onAction }]

  return (
    <div className={styles.menu}>
      <div className={styles.contentContainer}>
        {menuItems.map((item) => (
          <Item key={item.label} icon={item.icon} alt={item.label} label={item.label} onClick={item.onAction} />
        ))}
      </div>
    </div>
  )
}

export default DomainMoreOptions
